import { 
IonCardHeader, IonCardTitle,
  } from '@ionic/react'

function SignUpHeader () {
    return (
        <>
            <IonCardHeader>
                <img src='img/logo.png' className='logo-img'></img>
                    <IonCardTitle><h1>Get Started</h1></IonCardTitle>
                    <p>Sign up as a business to enjoy full RydeSEND features</p>
            </IonCardHeader>
        </>
    )
}

export default SignUpHeader;